/// <reference path="appbase.ts" />


namespace TerminalApp {
    let appId = "app_move_stock";



    class RestockListElement {
        index: number = 0;
        data: SP.RestockListInfo;
        html: HTMLElement;
        menu: SP.SwipeMenu;

        text_name: HTMLElement;
        text_date: HTMLElement;
        text_location: HTMLElement;
        text_description: HTMLElement;
        text_icon: HTMLImageElement;

        occupant_info: HTMLElement;


        constructor(data: SP.RestockListInfo) {
            this.data = data;

            this.html = CreateButton("/terminal/img/icon/list2.png", null);
            this.html.classList.add("full");
            this.html.style.height = "88px";

            this.menu = new SP.SwipeMenu(
                /*Element*/
                this.html,

                /*Click Event*/
                () => {
                    GetApp("app_move_stock").open({ restocklist: this.data.id });
                },

                /*buttons*/
                [

                /*Cancel Button*/{
                        icon: "<i class='fas fa-trash'></i>", text: SP.Localize("word_cancel"), color: "#e83535", confirm: true, action: async () => {
                            StartLoading();
                            var result = await SP.get<any>("/api/v1/restock/cancel/" + this.data.id);
                            console.log(result);
                            if (result.status == 200) {
                                SP.Sounds.Success.play();
                                this.menu.return();
                                this.html.remove();
                                this.menu.remove();
                                App_Move_Stock.instance.loadToteList();
                            }
                            else {
                                this.menu.return();
                                SP.alertX(`${result.status}: ${result.msg}`);
                                if (result.exception) { console.log(result.exception); }
                            }
                            StopLoading();
                        }
                    },

                ],
                /*group*/
                "app_restock_totes"
            );


            this.updateText();



        }



        updateText() {
            //clear
            this.html.innerHTML = "";

            var inner = this.html.appendChild(document.createElement("div"));

            //icon
            this.text_icon = inner.appendChild(document.createElement("img"));
            this.text_icon.classList.add("icon");
            this.text_icon.src = "/terminal/img/icon/list2.png";

            //date/user text
            this.text_date = inner.appendChild(document.createElement("div"));
            this.text_date.classList.add("text", "bottom", "right", "small");
            this.text_date.innerHTML = `${this.data.user} <span class='bold'>${this.data.time}</span>`;

            //name
            this.text_name = inner.appendChild(document.createElement("div"));
            this.text_name.classList.add("text", "top", "big", "left");
            this.text_name.style.right = "130px";
            //this.text_name.innerHTML = `<span class="label">${this.data.lines.length} Totes</span> ${this.data.stockName} #${this.data.id}`;
            this.text_name.innerHTML = `${this.data.stockName} #${this.data.id}`;

            //date/user name
            this.text_description = inner.appendChild(document.createElement("div"));
            this.text_description.classList.add("text", "left", "small");
            this.text_description.style.lineHeight = "16px";
            this.text_description.innerHTML = `<span class="bold">${this.data.lines.length + " " + SP.Localize("word_locations")}</span>`;

            //date/user name
            this.text_location = inner.appendChild(document.createElement("div"));
            this.text_location.classList.add("text", "top", "right");
            this.text_location.innerHTML = `<span class="label">${Math.round(this.data.routeLength)} m</span>`;


            //inner.style.opacity = this.data.occupantUserName ? "0.5" : "1";
            //this.html.style.pointerEvents = this.data.occupantUserName ? "none" : "all";
            //this.html.style.backgroundColor = this.data.occupantUserName ? "rgba(255,255,255,0.3)" : "#fff";

            //if (this.data.occupantUserName) {

            //    if (!this.occupant_info) {
            //        this.occupant_info = document.createElement("div");
            //        this.occupant_info.classList.add("occupant_info");
            //    }
            //    this.occupant_info.innerHTML = this.data.occupantUserName;
            //    this.html.appendChild(this.occupant_info);
            //}
        }
    }

    class RestockListLineElement {
        index: number = 0;
        data: SP.RestockListLineInfo;
        html: HTMLElement;
        menu: SP.SwipeMenu;

        text_name: HTMLElement;
        text_date: HTMLElement;
        text_location: HTMLElement;
        text_description: HTMLElement;
        text_icon: HTMLImageElement;

        occupant_info: HTMLElement;
        static activeElement: RestockListLineElement = null;

        setActive() {
            this.html.style.opacity = "1";
            RestockListLineElement.activeElement = this;
            for (var i = 0; i < App_Move_Stock.instance.infos.length; i++) {
                let elm = App_Move_Stock.instance.infos[i];
                var moveQty = this.data.moveLots[elm.id] ?? 0;


                //move to top
                if (moveQty) {
                    let elm_container = (elm as any).dood.track.parentElement as HTMLElement;
                    elm_container.parentElement.prepend(elm_container);

                    //set new max move from refill qty
                    if (moveQty != elm.placementQuantity) {
                        elm.placementQuantity = moveQty;
                        var val1 = elm_container.querySelector(".move_max_value") as HTMLElement;
                        var val2 = elm_container.querySelector(".move_max_value2") as HTMLElement;
                        val2.style.color = "#809b4d";
                        val2.innerHTML = " / " + val1.innerHTML;
                        val1.innerHTML = moveQty.toString();
                    }

                }

                (elm as any).dood.checked = moveQty > 0;
                (elm as any).dood.onChange();
            }
        }

        constructor(data: SP.RestockListLineInfo) {

            this.data = data;
            let currentLine = SP.getHash("restocklistline");

            this.html = CreateButton(null, null);
            this.html.classList.add("full");
            this.html.style.height = "88px";
            this.html.style.opacity = "0.6";

            if (currentLine == this.data.id) {
                this.setActive();
            }
            var pi2: PlacementInfoBox;
            if (data.fromPlacementData) {
                var pi1 = new PlacementInfoBox(data.fromPlacementData, true, null);
                pi1.container.setAttribute("style", "position:absolute; width:30%; left:0; pointer-events:none !important")
                pi1.container.querySelector("img").setAttribute("style", "pointer-events:none !important")
                this.html.appendChild(pi1.container);
            }
            if (data.toPlacementData) {
                pi2 = new PlacementInfoBox(data.toPlacementData, true, null);
                pi2.container.setAttribute("style", "position:absolute; width:50%; right:0; pointer-events:none !important")
                pi2.container.querySelector("img").setAttribute("style", "pointer-events:none !important")
                this.html.appendChild(pi2.container);
            }

            var clickFn = () => {
                SP.setManyHash({ toPlacementId: this.data.toPlacementId?.toString(), placementId: this.data.fromPlacementId?.toString(), restocklistline: this.data.id });
            };

            this.menu = new SP.SwipeMenu(
                /*Element*/
                this.html,

                /*Click Event*/
                () => {
                    clickFn();
                },

                /*buttons*/
                [

                /*Cancel Button*/{
                        icon: "<i class='fas fa-trash'></i>", text: SP.Localize("word_remove"), color: "#e83535", confirm: true, action: async () => {
                            StartLoading();
                            var result = await SP.get<any>("/api/v1/restock/removeLine/" + this.data.id);
                            if (result.status == 200) {
                                SP.Sounds.Success.play();
                                this.menu.return();
                                this.html.remove();
                                this.menu.remove();
                                App_Move_Stock.instance.loadToteList();
                            }
                            else {
                                this.menu.return();
                                SP.alertX(`${result.status}: ${result.msg}`);
                                if (result.exception) { console.log(result.exception); }
                            }
                            StopLoading();
                        }
                    },
                    /*Change Button*/{
                        icon: "<i class='fas fa-recycle'></i>", text: SP.Localize("word_change"), color: "blue", confirm: false, action: async () => {

                            TerminalApp.placementFinderAssistant.open(async (placementId, placementData) => {
                                if (placementData) {

                                    await SP.get<any>("/api/v1/restock/changeLine/" + this.data.id + "?placementId=" + placementId);

                                    pi2.container.remove();
                                    pi2 = new PlacementInfoBox(placementData, true, null);
                                    pi2.container.setAttribute("style", "position:absolute; width:50%; right:0; pointer-events:none !important")
                                    pi2.container.querySelector("img").setAttribute("style", "pointer-events:none !important")
                                    this.html.appendChild(pi2.container);
                                    this.data.toPlacementId = placementId;

                                    //reload
                                    if (RestockListLineElement.activeElement == this) {
                                        TerminalApp.hashChanged();
                                    }
                                }
                            });

                            this.menu.return();

                        }
                    },
                ],

                /*group*/
                "app_restock_totes"
            );
        }
    }

    export class App_Move_Stock extends AppBase {
        msq_sticky_footer = document.getElementById("msq_sticky_footer");
        msq_filter_toggle = new SP.CheckboxDoodle(document.getElementById("msq_filter_toggle") as HTMLInputElement);
        msq_filter = document.getElementById("msq_filter") as HTMLInputElement;

        msq_info = document.getElementById("msq_info");
        msq_info_image = this.msq_info.querySelector("img");
        msq_data = document.getElementById("msq_data");
        msq_from_location = document.getElementById("msq_from_location");
        msq_to_location = document.getElementById("msq_to_location");
        msq_to_location_info = document.getElementById("msq_to_location_info");
        msq_to_location_info_image = this.msq_to_location_info.querySelector("img");;
        msq_items = document.getElementById("msq_items");
        msq_error = document.getElementById("msq_error");
        msq_confirm = document.getElementById("msq_confirm");
        msq_parked_count = document.getElementById("msq_parked_count");
        msq_parked_list = document.getElementById("msq_parked_list");
        msq_parked_button = document.getElementById("msq_parked_button");
        msq_refill_list = document.getElementById("msq_refill_list");
        msq_refill_area = document.getElementById("msq_refill_area");
        msq_tote_list = document.getElementById("msq_tote_list");
        msq_tote_area = document.getElementById("msq_tote_area");
        msq_restock_list = document.getElementById("msq_restock_list");
        msq_restock_area = document.getElementById("msq_restock_area");
        msq_restocklist_list = document.getElementById("msq_restocklist_list");
        msq_restocklist_area = document.getElementById("msq_restocklist_area");

        msq_create_restocking_list_button = document.getElementById("msq_create_restocking_list_button");

        cb_all_totes: SP.CheckboxDoodle;

        //input_popup = new Input_Popup();
        hasItems = false;
        bound = false;
        fromPlacementId: string = null;
        toPlacementId: string = null;
        showParked: boolean;
        toScanTime: number = 0;
        static instance: App_Move_Stock;

        stickyWrapper: HTMLElement;
        stickyFooter: HTMLElement;
        stickyObserver: IntersectionObserver;
        constructor() {



            super(appId);

            //Make it stick
            this.stickyWrapper = document.getElementById('msq_sticky_footer_wrapper');
            this.stickyFooter = document.getElementById('msq_sticky_footer');
            this.stickyObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    // check if the element is exiting from the bottom
                    if (!entry.isIntersecting && entry.boundingClientRect.top >= 0) {
                        this.stickyFooter.style.position = 'fixed';
                        this.stickyFooter.style.bottom = '0';
                    } else if (entry.isIntersecting || entry.boundingClientRect.top < 0) {
                        this.stickyFooter.style.position = 'static';
                    }
                });
            }, { root: null, rootMargin: '0px', threshold: 1 });


            this.showParked = SP.getHash("parked") == "true";

            this.msq_parked_button.addEventListener("click", () => {
                this.showParked = !this.showParked;
                SP.setHash("parked", this.showParked.toString())
            });


            this.msq_create_restocking_list_button.addEventListener("click", () => {
                this.createRestockList();
            })


            let to: any = -1;
            this.msq_filter.addEventListener("keyup", () => {
                clearTimeout(to);

                to = setTimeout(() => {
                    this.loadPlacementItems(this.fromPlacementId, this.msq_filter.value);
                }, 500);
            });

            this.msq_filter_toggle.onChange = () => {
                for (let i = 0; i < this.infos.length; i++) {
                    (this.infos[i] as any).dood.checked = this.msq_filter_toggle.checked;
                    (this.infos[i] as any).dood.onChange();
                }
            };

            this.msq_filter_toggle.track.style.position = "absolute";
            this.msq_filter_toggle.track.style.zIndex = "1000";
            this.msq_filter_toggle.track.style.top = "168px";
            this.msq_filter_toggle.track.style.right = "10px";
            this.msq_filter_toggle.track.style.setProperty("margin-top", "0px", "important");

            this.msq_confirm.addEventListener("click", () => {
                this.performMove();
            });
            App_Move_Stock.instance = this;



            //select all checkbox
            var cb = this.msq_tote_area.appendChild(document.createElement("input"));
            cb.type = "checkbox";
            var cd = this.cb_all_totes = new SP.CheckboxDoodle(cb);
            cd.track.setAttribute("style", "position:absolute; left:9px; top:-5px; margin:0px !important;");
            cd.onChange = () => {
                for (var i = 0; i < this.totes.length; i++) {
                    this.totes[i].checkbox.checked = cd.checked;
                }
            }
            this.msq_info_image.style.pointerEvents = "all";
            this.msq_info_image.addEventListener("click", () => {
                placementPickerAssistant.open(this.currentCustomerId, null, (p) => {
                    this.scanPlacement(p.id.toString());
                });
            });


            this.msq_to_location_info_image.style.pointerEvents = "all";
            this.msq_to_location_info_image.addEventListener("click", () => {
                placementPickerAssistant.open(this.currentCustomerId, null, (p) => {
                    this.scanPlacement(p.id.toString());
                });
            });
        }

        resetError() {
            this.msq_error.style.display = "none";
            this.msq_error.innerHTML = "";
        }

        reset() {
            this.cb_all_totes.checked = false;
            this.msq_filter.value = "";
            this.msq_confirm.style.display = "none";
            this.msq_info.style.display = "block";
            this.msq_data.style.display = "none";
            this.msq_to_location_info.style.display = "block";
            this.msq_to_location.style.display = "none";
            this.msq_from_location.innerHTML = "";
            this.msq_to_location.innerHTML = "";
            this.currentCustomerId = null;
            this.msq_items.innerHTML = "";
            this.msq_filter_toggle.checked = true;
            this.fromPlacementId = null;
            this.toPlacementId = null;
            this.toScanTime = 0;
            this.stickyObserver.unobserve(this.stickyWrapper);
            this.msq_sticky_footer.style.position = 'static';


            this.resetError();
            //this.input_popup.hide();


            this.msq_refill_area.style.display = "none";
            this.msq_restocklist_area.style.display = "none";
            this.msq_restock_area.style.display = "none";
            this.msq_tote_area.style.display = "none";
        }



        showError(message: string) {
            this.msq_error.innerHTML = message;
            this.msq_error.style.display = "block";
            SP.Sounds.Error.play();
        }

        infos: SP.StockingLotInfo[] = [];

        currentCustomerId: string;
        async loadPlacementItems(placementId: string, itemsearch: string) {
            this.currentCustomerId = null;
            this.msq_items.innerHTML = "";

            var response = await SP.get<any>("/api/v1/info/stockingLotInfos/?maxResults=100&placementId=" + placementId + "&itemFilter=" + (itemsearch ?? ''));

            if (response.status == 200) {
                this.infos = (response.data as SP.StockingLotInfo[]).filter(info => info.placementQuantity > 0);

                if (!itemsearch) document.documentElement.scrollTop = 0;

                var default_checked = this.infos.length <= 1;
                this.msq_filter_toggle.checked = default_checked;

                this.infos.forEach(i => {
                    this.currentCustomerId = i.item.customerId;
                    let name = `${i.item.manufacturerName} ${i.item.modelNo}`.trim();

                    //elm
                    let item = document.createElement("div");
                    item.classList.add("item");
                    item.style.opacity = default_checked ? "1" : "0.5";

                    //tempalte
                    item.innerHTML = `
                    <input type="checkbox" value="${i.id}" ${(default_checked ? 'checked' : '')} name="skus" class="msq_sku_checkbox">
                    <span class="image">
                        <img src="${i.item.imageUrl}">
                    </span>
                    <span>
                        <div class="description">
                            <b>${i.item.sku} ${((name ? ` (${name})` : ""))}</b>${(i.item.barcodes?.length > 0 ? '<small> ' + i.item.barcodes.join(',') + '</small>' : '')}<br />${i.item.description}<br />
                            ${this.GetLotBadges(i, true).outerHTML}
                        </div>
                    </span>
                    <span class="label label_input">
                        <input type="number" class='count_input' id="msq_count_${i.id}" value="${(App_Settings.wmsSettings.move_all_placement ? i.placementQuantity.toString() : '0')}">
                        <span class="move_max"><div class="text">Max</div><span class='move_max_value'>${i.placementQuantity}</span><span class='move_max_value2'></span></span>
                    </span>`;

                    //show other placements
                    if (i.item.totalCombined > i.availableQuantity || i.item.preferredStockPlacementId) {
                        item.innerHTML += `
                        <span class="info-button">
                            <i class='fas fa-info-circle'></i>
                        </span>
                        <div class="info-box"></div>`;

                        let infoBox = item.querySelector(".info-box") as HTMLElement;
                        let info = item.querySelector(".info-button") as HTMLElement;
                        let loaded = false;

                        let up = () => { infoBox.style.display = "none"; window.removeEventListener("pointerup", up); }
                        info.addEventListener("pointerdown", async () => {
                            window.addEventListener("pointerup", up);
                            if (!loaded) {
                                loaded = true;
                                let data = await SP.Data.StockingLot.getItemStockingLotInfos(i.item.id);

                                if (i.item.preferredStockPlacementData && data.filter(lot => lot.stockPlacementData == i.item.preferredStockPlacementData).length == 0) {
                                    infoBox.innerHTML += `<span class='label label_input label_extra'><i class="fa-solid fa-star"></i></span>`;
                                    infoBox.appendChild(new PlacementInfoBox(i.item.preferredStockPlacementData, true, null).container);
                                }

                                data.filter(lot => lot.id != i.id).forEach(lot => {
                                    infoBox.innerHTML += `<span class='label label_input label_extra'>${lot.placementQuantity}</span>`;
                                    infoBox.appendChild(new PlacementInfoBox(lot.stockPlacementData, true, null).container);
                                });
                            }
                            infoBox.style.display = "block";
                        });
                    }

                    //blur on enter
                    let count_input = item.querySelector(".count_input") as HTMLInputElement;
                    console.log("input:", count_input);
                    count_input.addEventListener("keydown", (e: KeyboardEvent) => { if (e.keyCode == 13) { count_input.blur(); return false; } return true; });

                    //select all on focus
                    count_input.addEventListener("focus", () => { count_input.select(); });

                    //click to autofill max
                    let total_span = item.querySelector(".move_max");
                    total_span.addEventListener("click", () => {
                        var newVal = i.placementQuantity.toString();
                        count_input.value = count_input.value == newVal ? "0" : newVal;
                    });
                    count_input.focus();

                    //click for item info
                    let image_span = item.querySelector(".image");
                    image_span.addEventListener("click", (e) => {
                        itemShortcutAssistant.open_with_info(i.item);
                        e.preventDefault(); e.stopPropagation();
                    });

                    //Create checkbox doodle
                    let checkbox = item.querySelector(".msq_sku_checkbox") as HTMLInputElement;
                    (i as any).dood = new SP.CheckboxDoodle(checkbox);
                    (i as any).dood.onChange = () => { item.style.opacity = checkbox.checked ? "1" : "0.5"; };

                    this.msq_items.appendChild(item);

                });
            }
        }

        async createRestockList() {
            var toteIds: number[] = [];
            for (let i = 0; i < this.totes.length; i++) {
                let box = this.totes[i];
                if (box.checkbox.checked) {
                    toteIds.push(box.toteId);
                }
            }

            toteAndPlacementPickerAssistant.openWithTotes(toteIds, null, async (info) => {
                this.msq_create_restocking_list_button.classList.add("disabled");
                StartLoading();

                var result = await SP.post<any>("/api/v1/restock/create/", {
                    startLocationId: info.id,
                    ToteIds: toteAndPlacementPickerAssistant.tote_ids
                });

                if (result.status != 200) {
                    this.showError(result.msg);
                }
                else {
                    SP.Sounds.Success.play();
                }

                StopLoading();
                this.msq_create_restocking_list_button.classList.remove("disabled");
                SP.setAllHash({ "app": "app_move_stock", "restocklist": result.listId });

            });
        }

        async selectPlacementId(placementId: string, itemsearch: string) {


            if (!placementId) return;
            //if (placementId != this.fromPlacementId || itemsearch) {
            //this.reset();
            this.resetError()

            var samePlacement = this.fromPlacementId == placementId;


            //plus count instead of reload
            if (samePlacement && !App_Settings.wmsSettings.move_all_placement) {



                for (var i = 0; i < App_Move_Stock.instance.infos.length; i++) {
                    let elm = App_Move_Stock.instance.infos[i];
                    let elm_container = (elm as any).dood.track.parentElement;



                    if (elm_container.outerHTML.includes(itemsearch)) {

                        var isChecked = (elm as any).dood.checked;
                        if (this.isRestockListOpen) {
                            //wrong item scan
                            if (!isChecked) {
                                SP.Sounds.Error.play();
                                this.showError(SP.Localize("sentance_scanning_wrong_item"));
                                return
                            }
                        }


                        (elm as any).dood.checked = true;
                        (elm as any).dood.onChange();
                        var inp = elm_container.querySelector(".count_input") as HTMLInputElement;
                        inp.value = (parseFloat(inp.value) + 1).toString();
                        elm_container.parentElement.prepend(elm_container);
                        return;
                    }
                }

                if (this.isRestockListOpen) {
                    SP.Sounds.Error.play();
                    this.showError(SP.Localize("sentance_scanning_wrong_item")!);
                    return;
                }
            }



            this.fromPlacementId = placementId;


            ignoreHashChange = true;
            SP.setHash("placementId", placementId);



            //get items

            ////Too many Items (must filter)
            //else if (response.status == 519) {
            //    SP.Sounds.Error.play();
            //    this.input_popup.show("Too many items on location, filter or scan item!", "Filter", "Filter / ean ...", () => {
            //        this.selectPlacementId(placementId, this.input_popup.value);
            //    });
            //}

            await this.loadPlacementItems(placementId, itemsearch);
            //var fromplacementInfo = await SP.Data.Stock.getPlacementInfo(parseInt(placementId));



            this.hasItems = this.infos.length > 0;
            if (!this.hasItems) return this.showError(SP.Localize("sentance_no_items_found") + "!");

            if (this.hasItems && !samePlacement) {
                const placement_box = new PlacementInfoBox(this.infos[0].stockPlacementData, true, null);
                this.msq_from_location.appendChild(placement_box.container);
            }

            this.msq_filter.style.display = this.msq_filter_toggle.track.style.display = this.infos.length > 1 ? "block" : "none";

            this.msq_info.style.display = "none";
            this.msq_data.style.display = "block";
            this.fromPlacementId = placementId;
            //}
        }

        async scanTote(toteId: string) {
            if (this.isRestockListOpen) {
                for (var lineId in this.restocklistLines) {
                    let rll = this.restocklistLines[lineId];
                    if (toteId == rll.data.fromToteId.toString()) {
                        rll.menu.click();
                        return;
                    }
                }
            }



            var toteInfo = await SP.Data.Tote.getToteInfo(toteId, true);
            await this.scanPlacement(toteInfo.totePlacementId.toString());
        }

        async scanBarcode(bc: string) {
            //if (this.input_popup.open) {
            //    this.input_popup.setExecute(bc);
            //}
            //else {
            console.log("from", this.fromPlacementId);
            if (this.fromPlacementId) {
                this.selectPlacementId(this.fromPlacementId, bc);
            }
            else {
                itemSearchAssistant.open(null, bc, false, (iteminfo) => {
                    if (iteminfo != null) {
                        itemShortcutAssistant.open_with_info(iteminfo);
                    }
                });
            }
            //}

        }

        scanning = false;
        async scanPlacement(placementId: string) {
            if (this.scanning) return;
            this.scanning = true;
            try {
                if (!placementId) return;

                if (this.fromPlacementId == null || this.fromPlacementId == placementId || !this.hasItems) {
                    return await this.selectPlacementId(placementId, '');
                }

                var now = performance.now();

                //double scan
                if (placementId == this.toPlacementId && now - this.toScanTime <= 1000) {
                    return await this.performMove();
                }
                else {
                    //change location from restock list?
                    if (this.isRestockListOpen && this.toPlacementId && this.toPlacementId != placementId && !await SP.confirmX(SP.Localize("text_move_change_location") + "?")) return;

                    this.toScanTime = now;
                    if (this.toPlacementId != placementId)
                        await this.selectToPlacement(placementId);
                    if (App_Settings.userSettings.auto_double_scan_moving) return await this.performMove();

                }
            }
            finally {
                this.scanning = false;
            }
        }

        async selectToPlacement(placementId: string) {



            this.toPlacementId = placementId;
            var toLocation = await SP.Data.Stock.getPlacementInfo(placementId as any, true);
            const to_placement_box = new PlacementInfoBox(toLocation.data, true, null);
            this.msq_to_location.innerHTML = "";
            this.msq_to_location.appendChild(to_placement_box.container);
            this.msq_to_location_info.style.display = "none";
            this.msq_to_location.style.display = "block";
            ignoreHashChange = true;
            SP.setHash("toPlacementId", placementId);
            this.msq_confirm.style.display = "block";



            setTimeout(() => {
                this.stickyWrapper.style.minHeight = `${this.stickyFooter.offsetHeight}px`;
                this.stickyFooter.style.position = 'static';
                this.stickyFooter.style.width = `${this.container.offsetWidth}px`;
                this.stickyObserver.observe(this.stickyWrapper);
            }, 10);
        }

        async performMove() {
            var markedCheckbox = document.querySelectorAll('.msq_sku_checkbox:checked') as any;
            var ids: any = {};

            for (var checkbox of markedCheckbox) {
                var id = checkbox.value;
                var qty = parseFloat((document.getElementById("msq_count_" + id) as HTMLInputElement).value);
                if (qty > 0) {
                    ids[id] = qty;
                }
            }
            let currentRestockListLine = SP.getHash("restocklistline");
            var postData = { from: this.fromPlacementId, to: this.toPlacementId, ids: ids, restockListLineId: currentRestockListLine };
            console.log("postData:", postData);

            if (Object.keys(ids).length == 0) {
                this.showError("NoItemsMoved");
                return;
            }

            var result = await SP.post<any>("/api/v1/stockinglot/move", postData);

            var restocklistId = SP.getHash("restocklist") ?? undefined;

            if (result.status == 200) {
                this.reset();
                SP.setAllHash({ "app": "app_move_stock", "restocklist": restocklistId });
                SP.Sounds.Success.play();
            }
            else {
                this.showError(result.msg);
            }
            console.log(result);
        }


        GetLotBadgesRefill(refillInfo: SP.ItemRefillInfo) {
            let info = document.createElement("span");

            if (refillInfo.itemReservedQuantity > 0) {
                let label = document.createElement("span");
                label.classList.add("label");
                label.innerHTML = "<b>" + refillInfo.itemReservedQuantity + "</b> " + SP.Localize("sentance_in_order") + " (" + refillInfo.itemReservedToCountries + ")";
                info.appendChild(label);
                info.innerHTML += " ";
            }

            if (refillInfo.itemRefillRequired) {
                let label = document.createElement("span");
                label.classList.add("label");
                label.innerHTML = '<i class="fa far fa-circle-exclamation"></i>';
                label.style.backgroundColor = "#ff771e";
                info.appendChild(label);
                info.innerHTML += " ";
            }

            if (refillInfo.item.refillLimit) {
                let lable = document.createElement("span");
                lable.classList.add("label");
                lable.style.backgroundColor = "#4b7fe9";
                lable.innerHTML = SP.Localize("sentance_refill_limit") + ": " + refillInfo.item.refillLimit;
                info.appendChild(lable);
                info.innerHTML += " ";
            }

            if (refillInfo.item.refillMax) {
                var max = document.createElement("span");
                max.classList.add("label");
                max.style.backgroundColor = "#454545";
                max.innerHTML = SP.Localize("sentance_refill_max") + ": " + refillInfo.item.refillMax;
                info.appendChild(max);
                info.innerHTML += " ";
            }
            return info;
        }

        GetLotBadges(lot: SP.StockingLotInfo, soloView: boolean) {
            let info = document.createElement("span");

            //Show expiration
            if (soloView && lot.isReturn) {
                let label = document.createElement("span");
                label.classList.add("label");
                label.innerHTML = SP.Localize("word_return");
                label.style.backgroundColor = "#c63636";
                info.appendChild(label);
                info.innerHTML += " ";
            }

            //Show expiration
            if (soloView && lot.item.expirable) {
                let label = document.createElement("span");
                label.classList.add("label");
                label.innerHTML = lot.expirationDate;
                label.style.backgroundColor = "#636363";
                info.appendChild(label);
                info.innerHTML += " ";
            }

            //show arrival date
            else if (soloView && lot.item.useFifo) {
                let label = document.createElement("span");
                label.classList.add("label");
                label.innerHTML = lot.arrivalDate;
                label.style.backgroundColor = "#636363";
                info.appendChild(label);
                info.innerHTML += " ";
            }

            //batch number
            if (soloView && lot.batchNumber) {
                let label = document.createElement("span");
                label.classList.add("label");
                label.innerHTML = lot.batchNumber;
                label.style.backgroundColor = "#636363";
                info.appendChild(label);
                info.innerHTML += " ";
            }

            if (lot.itemReservedQuantity > 0) {
                let label = document.createElement("span");
                label.classList.add("label");
                label.innerHTML = "<b>" + lot.itemReservedQuantity + "</b> " + SP.Localize("sentance_in_order") + " (" + lot.itemReservedToCountries + ")";
                info.appendChild(label);
                info.innerHTML += " ";
            }

            if (lot.itemRefillRequired) {
                let label = document.createElement("span");
                label.classList.add("label");
                label.innerHTML = '<i class="fa far fa-circle-exclamation"></i>';
                label.style.backgroundColor = "#ff771e";
                info.appendChild(label);
                info.innerHTML += " ";
            }

            if (lot.item.refillLimit) {
                let lable = document.createElement("span");
                lable.classList.add("label");
                lable.style.backgroundColor = "#4b7fe9";
                lable.innerHTML = SP.Localize("sentance_refill_limit") + ": " + lot.item.refillLimit;
                info.appendChild(lable);
                info.innerHTML += " ";
            }

            if (lot.item.refillMax) {
                var max = document.createElement("span");
                max.classList.add("label");
                max.style.backgroundColor = "#454545";
                max.innerHTML = SP.Localize("sentance_refill_max") + ": " + lot.item.refillMax;
                info.appendChild(max);
                info.innerHTML += " ";
            }
            return info;
        }

        private refillData: { key: string; value: SP.ItemRefillInfo[] }[] = [];
        async loadRefillList() {
            const refillData = this.refillData = await SP.Data.StockingLot.getRefillStockingLotInfos();
            const showParked = this.showParked;

            // Clear containers
            this.msq_refill_list.innerHTML = "";
            this.msq_parked_list.innerHTML = "";

            // Track headers and counts
            const headerCountMap = new Map<string, { element: HTMLElement; count: number }>();

            for (let i = 0; i < refillData.length; i++) {
                const locationData = refillData[i];
                const locationKey = locationData.key;
                const allItems = locationData.value;

                // Filter items based on parked state
                const items = allItems.filter(x => x.item.refillParked === showParked);
                if (items.length === 0) continue;

                const locClass = "loc_" + i;
                let isVisible = true;
                let loadedCount = 0;

                // Create header
                const header = document.createElement("h1");
                header.innerHTML = `<span class="arrow" style="display:inline-block; transition: transform 0.3s; transform: rotate(90deg); position:absolute; left:25px;">▶</span> ${locationKey} (${items.length})`;
                header.style.backgroundColor = "black";
                header.style.color = "white";
                header.style.padding = "20px";
                header.style.marginBottom = "-5px";
                header.style.cursor = "pointer";

                headerCountMap.set(locationKey, { element: header, count: items.length });

                header.addEventListener("click", () => {
                    isVisible = !isVisible;
                    const elms = document.querySelectorAll("." + locClass);
                    elms.forEach(e => {
                        (e as HTMLElement).style.display = isVisible ? "" : "none";
                    });
                    const arrow = header.querySelector(".arrow") as HTMLElement;
                    if (arrow) arrow.style.transform = isVisible ? "rotate(90deg)" : "rotate(0deg)";
                });

                const parentList = showParked ? this.msq_parked_list : this.msq_refill_list;
                parentList.appendChild(header);

                // Container for item boxes
                const locationContainer = document.createElement("div");
                parentList.appendChild(locationContainer);

                // Scroll sentinel
                const sentinel = document.createElement("div");
                sentinel.classList.add("scroll-sentinel");
                locationContainer.appendChild(sentinel);

                const loadMoreItems = () => {
                    const end = Math.min(loadedCount + 10, items.length);
                    for (let x = loadedCount; x < end; x++) {
                        const itemRefillData = items[x];
                        const box = new LotInfoRefillBox(itemRefillData);
                        box.text_container.appendChild(this.GetLotBadgesRefill(itemRefillData));

                        const box_container = document.createElement("div");

                        const menu = new SP.SwipeMenu(
                            box.container,
                            null,
                            [{
                                icon: "<i class='fa-duotone fa-clock-one'></i>",
                                text: SP.Localize("sentance_park_unpark_refill"),
                                color: "#3e7faf",
                                confirm: false,
                                action: async () => {
                                    itemParkingAssistant.open(itemRefillData.item, (parked) => {
                                        const wasParked = itemRefillData.item.refillParked;
                                        const nowParked = parked;

                                        // Remove from current list
                                        box_container.remove();

                                        // Update header count
                                        const headerInfo = headerCountMap.get(locationKey);
                                        if (headerInfo) {
                                            headerInfo.count -= 1;
                                            const arrow = headerInfo.element.querySelector(".arrow")?.outerHTML || "▶";
                                            headerInfo.element.innerHTML = `${arrow} ${locationKey} (${headerInfo.count})`;
                                        }

                                        // Move to other list
                                        if (nowParked) {
                                            this.msq_parked_list.appendChild(box_container);
                                        } else {
                                            this.msq_refill_list.appendChild(box_container);
                                        }

                                        this.updateParkedAndRefillInfo();
                                    });
                                    menu.return();
                                }
                            }],
                            "app_restock_totes"
                        );

                        box_container.appendChild(box.container);
                        box_container.classList.add(locClass);
                        box_container.style.display = isVisible ? "" : "none";
                        locationContainer.appendChild(box_container);
                        locationContainer.appendChild(sentinel); // keep sentinel at bottom
                    }

                    loadedCount = end;

                    if (loadedCount >= items.length) {
                        observer.unobserve(sentinel);
                        sentinel.remove();
                    }
                };

                const observer = new IntersectionObserver((entries) => {
                    if (entries[0].isIntersecting) {
                        loadMoreItems();
                    }
                }, {
                    root: null,
                    rootMargin: "0px",
                    threshold: 1.0
                });

                observer.observe(sentinel);

                // Initial fill
                const ensureInitialFill = () => {
                    loadMoreItems();
                    setTimeout(() => {
                        if (document.body.scrollHeight <= window.innerHeight && loadedCount < items.length) {
                            ensureInitialFill();
                        }
                    }, 100);
                };

                ensureInitialFill();
            }

            this.updateParkedAndRefillInfo();
        }


        updateParkedAndRefillInfo() {
            // fallback if data not loaded yet
            if (!this.refillData) return;

            let parkedCount = 0;
            let refillCount = 0;

            for (let i = 0; i < this.refillData.length; i++) {
                const group = this.refillData[i].value;
                for (let j = 0; j < group.length; j++) {
                    if (group[j].item.refillParked) {
                        parkedCount++;
                    } else {
                        refillCount++;
                    }
                }
            }

            const hasRefill = parkedCount + refillCount > 0;

            // Show count of opposite list (to offer switching)
            this.msq_parked_count.innerHTML =
                (this.showParked ? refillCount : parkedCount) + " " +
                (this.showParked ? SP.Localize("word_normal") : SP.Localize("word_parked"));

            this.msq_parked_button.style.display =
                (this.showParked && refillCount > 0 || !this.showParked && parkedCount > 0)
                    ? "flex"
                    : "none";

            this.msq_refill_area.style.display = hasRefill ? "block" : "none";
            this.msq_parked_list.style.display = hasRefill && this.showParked ? "block" : "none";
            this.msq_refill_list.style.display = hasRefill && !this.showParked ? "block" : "none";
        }

        totes: ToteContentInfoBox[];

        async loadToteList() {
            this.totes = [];
            var data = await SP.Data.Tote.getMoveToteInfos();
            //console.log(data);

            this.msq_tote_list.innerHTML = "";
            this.msq_tote_area.style.display = data.length ? "block" : "none";

            for (let i = 0; i < data.length; i++) {
                let ti = data[i];
                let box = new ToteContentInfoBox(ti);
                this.msq_tote_list.appendChild(box.container);
                box.inner_container.addEventListener("click", () => {
                    SP.setAllHash({ "app": "app_move_stock", "placementId": box.placementId.toString() });
                });
                this.totes.push(box);
            }
        }

        restocklists: { [id: number]: RestockListElement } = {};
        async loadRestockLists() {
            this.restocklists = {};
            var data = await SP.Data.RestockList.getRestockListInfos();
            //console.log("restock lists:", data);

            this.msq_restock_list.innerHTML = "";
            this.msq_restock_area.style.display = data.length ? "block" : "none";

            for (let i = 0; i < data.length; i++) {
                let ri = data[i];
                this.RestockListAdded(ri);
            }
        }


        restocklistLines: { [id: string]: RestockListLineElement } = {};
        async loadRestockListLines(id: number) {
            this.restocklistLines = {};
            var data = await SP.Data.RestockList.getRestockListInfo(id);

            //list finishied  
            if (!data) {
                await this.close();
                this.open();
                return;
            }
            this.msq_restocklist_list.innerHTML = "";
            this.msq_restocklist_area.style.display = data != null ? "block" : "none";

            for (let i = 0; i < data.lines.length; i++) {
                let ri = data.lines[i];
                this.RestockListLineAdded(ri);
            }
        }

        RestockListLineAdded(data: SP.RestockListLineInfo) {
            var current = this.restocklistLines[data.id];
            if (current == null) {
                current = this.restocklistLines[data.id] = new RestockListLineElement(data);
                this.msq_restocklist_list.appendChild(current.html);
            }
        }

        RestockListAdded(data: SP.RestockListInfo) {
            var current = this.restocklists[data.id];
            if (current == null) {
                current = this.restocklists[data.id] = new RestockListElement(data);
                this.msq_restock_list.appendChild(current.html);
            }
        }

        RestockListUpdated(data: SP.RestockListInfo) {
            var current = this.restocklists[data.id];

            if (data.finished) {
                current.menu.remove();
                current.html.remove();
                delete this.restocklists[data.id];
                return;
            }

            current.data = data;
            current.updateText();
        }

        RestocklistDeleted(data: SP.RestockListInfo) {
            var current = this.restocklists[data.id];
            if (current != null) {
                current.menu.remove();
                current.html.remove();
            }
        }

        isRestockListOpen: boolean;

        async onOpen() {
            this.reset();
            await this.selectPlacementId(SP.getHash("placementId"), '');
            if (SP.getHash("toPlacementId")) await this.selectToPlacement(SP.getHash("toPlacementId"));



            var restocklistId = SP.getHash("restocklist");
            console.log("restocklistid:", restocklistId);
            if (restocklistId) {
                this.isRestockListOpen = true;
                await this.loadRestockListLines(parseInt(restocklistId));
            }
            else {
                this.isRestockListOpen = false;
                await this.loadRefillList();
                await this.loadToteList();
                await this.loadRestockLists();
            }
            //bind events and groups
            if (!this.bound) {
                this.bound = true;
                barcodeListener.on("sp", this.scanPlacement, this);
                barcodeListener.on("t", this.scanTote, this);
                barcodeListener.on(null, this.scanBarcode, this);
            }

            var filter = SP.getHash("filter");
            if (filter) {
                this.msq_filter.value = filter;
                this.loadPlacementItems(this.fromPlacementId, filter);
            }
        }

        async onClose() {


            //unbind events and groups
            if (this.bound) {
                this.bound = false;
                barcodeListener.off("sp", this.scanPlacement);
                barcodeListener.off("t", this.scanTote);
                barcodeListener.off(null, this.scanBarcode);
            }
            this.reset();
        }



    }

    RegisterApp(appId, App_Move_Stock);
}